import ticketTypes from './types';

export const initialStates = {
	list: null,
	created: null,
	indexed: null,
	comments: null,
	logs: null,
	support_problem: [],
};

const ticketReducers = (state = initialStates, action) => {
	switch (action.type) {
		case ticketTypes.LIST.SUCCESS: {
			return { ...state, list: action?.payload };
		}

		case ticketTypes.LIST.CLEAR: {
			return { ...state, list: null };
		}

		case ticketTypes.INDEX.SUCCESS: {
			return { ...state, indexed: action?.payload?.data };
		}

		case ticketTypes.CREATE.SUCCESS: {
			return { ...state, created: action?.payload };
		}

		case ticketTypes.COMMENT.SUCCESS: {
			return { ...state, comments: action?.payload };
		}

		case ticketTypes.COMMENT.CLEAR: {
			return { ...state, comments: null };
		}

		case ticketTypes.LOG.SUCCESS: {
			return { ...state, logs: action?.payload };
		}

		case ticketTypes.LOG.CLEAR: {
			return { ...state, logs: null };
		}
		case ticketTypes.SUPPORT_PROBLEM.SUCCESS: {
			return { ...state, support_problem: action?.payload };
		}

		case ticketTypes.SUPPORT_PROBLEM.CLEAR: {
			return { ...state, support_problem: [] };
		}

		default:
			return state;
	}
};

export default ticketReducers;
